<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

export default {
	page: {
		title: 'Контакты',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader },

	data() {
		return {
			title: 'Контакты',
			items: [],
            status: null,

            tableData: [],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],

            filter: null,
            filterOn: null,

            sortBy: 'id',
            sortDesc: false,

            fields: [
                { key: 'select',   label: '', row:{'rowSelected':false}},
                { key: 'id',       label: 'ID', sortable: true },
                { key: 'fullname', label: 'ФИО', sortable: true },
                { key: 'phone',    label: 'Номер телефона', sortable: true },
                { key: 'category_name', label: 'Группа', sortable: true },
                { key: 'status',    label: 'Статус'},
                { key: 'action',    label: ''},
            ],

            tableLoading: true,
            watch: false,
            disabled: true,
            select_all: false,
            selected: [],
		}
	},

    watch: {
        sortBy: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        sortDesc: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        perPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangePerPage();
                }
            }
        },
        currentPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangeCurrentPage();
                }
            }
        },
    },

    computed: {
        total_rows() {
            return this.$store.getters['contacts/GET_CONTACTS_TOTAL_ROWS'];
        },
        table_data() {
            this.tableLoading = false;
            return this.$store.getters['contacts/GET_CONTACTS_TABLE_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
        session_item(){
            return this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        }
    },

    async mounted() {	    
        if(this.session_user_item.role === 'administrator'){
            this.fields = [
                { key: 'select',   label: '', row:{'rowSelected':false}},
                { key: 'id',       label: 'ID', sortable: true },
                { key: 'fullname', label: 'ФИО', sortable: true },
                { key: 'phone',    label: 'Номер телефона', sortable: true },
                { key: 'category_name', label: 'Группа', sortable: true },
                { key: 'user_data', label: 'Пользователь', sortable: false },
                { key: 'status',    label: 'Статус'},
                { key: 'action',    label: ''},
            ]
        }
        await this.getData();
    },

	methods: {
        async deleteItems(){
            this.tableLoading = false;
            let uuid_list = []
            this.selected.forEach(el => {
                uuid_list.push(el.uuid);
            });

            let data_send = {
                'type' : 'contact',
                'uuid_list' : JSON.stringify(uuid_list),
            }
            await this.$store.dispatch('data/FETCH_DATA_DELETE', data_send);
            this.clearSelected();
            await this.getData();
        },
        async updateStatus(status = null){
            this.tableLoading = false;
            let uuid_list = []
            this.selected.forEach(el => {
                uuid_list.push(el.uuid);
            });

            let data_send = {
                'type' : 'contact',
                'uuid_list' : JSON.stringify(uuid_list),
                'params' : JSON.stringify({'status': status})
            }
            await this.$store.dispatch('data/FETCH_DATA_UPDATE', data_send);
            this.clearSelected();
            await this.getData();
        },
        async sortByStatus(status) {
            this.status = status;
            await this.getData();
        },        
        async onFiltered() {
            this.currentPage = 1;
            await this.getData();
        },
        async onSorted(){
            await this.getData();
        },
        async onChangePerPage(){
            this.currentPage = 1;
            await this.getData();
        },
        async onChangeCurrentPage(){
            await this.getData();
        },
        async getData(){
            this.tableLoading = true;
            this.selected = [];
            let data_send = {
                'status'   : this.status,
                'limit'    : this.perPage,
                'page'     : this.currentPage,
                'sortBy'   : this.sortBy,
                'sortDesc' : this.sortDesc === false ? 'ASC' : 'DESC',
                'filter'   : this.filter,
                'filterOn' : JSON.stringify(this.filterOn)
            }
            await this.$store.dispatch('contacts/FETCH_CONTACTS_LIST', data_send);
            this.watch = true;
        },
        onRowSelected(items) {
            this.selected = items;
            this.disabled = !this.selected.length > 0;
            this.select_all = this.selected.length === this.table_data.length;
        },
        selectRow(row) {
            if(row.rowSelected){
                this.$refs.table.selectRow(row.index);
            } else {
                this.$refs.table.unselectRow(row.index);
            }
        },
        selectAllRows() {
            if(this.select_all) {
                this.$refs.table.selectAllRows();
            } else {
                this.clearSelected();
            }
        },
        clearSelected() {
            this.$refs.table.clearSelected()
        },
	},
}
</script>

<template>
	<Layout>
        <div class="row page-title align-items-center">
            <div class="col-sm-2 col-xl-2">
                <h4 class="mb-1 mt-0"><i class="feather uil uil-user-check"></i>{{ title }}</h4>
            </div>
            <!-- <div class="col-sm-8 col-xl-6">
                <form class="form-inline float-sm-right mt-3 mt-sm-0">
                    <div class="btn-group">
                        <router-link to="/account/contacts/create" class="btn btn-primary" right>
                            <i class="uil uil-plus-circle " style="margin-right: 5px"></i>Новый контакт
                        </router-link>
                        <router-link to="/account/contacts/import" class="btn btn-outline-primary" right>
                            <i class="uil uil-down-arrow " style="margin-right: 5px"></i>Импортировать
                        </router-link>
                    </div>
                </form>
            </div> -->
			<div class="col-md-10 col-xl-10 text-md-right">
				<div class="mt-4 mt-md-0">
                    <form class="form-inline float-sm-right mt-3 mt-sm-0">
                        <div class="btn-group">
                            <router-link to="/account/contacts/create" class="btn btn-primary" right>
                                <i class="uil uil-plus" style="margin-right: 5px"></i>Новый контакт
                            </router-link>
                            <router-link to="/account/contacts/import" class="btn btn-outline-primary" right>
                                <i class="uil uil-down-arrow" style="margin-right: 5px"></i>Импортировать
                            </router-link>
                        </div>
                    </form>					
				</div>
			</div>
        </div>

        <div class="row">            
            <div class="col-12">

                <div class="row" style="margin-top: 20px; margin-bottom: 5px">
                    <div class="col-sm-3 col-md-3">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Показывать&nbsp;
                                <b-form-select
                                    v-model="perPage"
                                    size="md"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;записей
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-9 col-md-9">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <div class="btn-group ml-1 mr-2">
                                <button type="button" :class="status === null ? 'btn btn-primary' : 'btn btn-white'" @click="sortByStatus(null)"><i class="feather uil uil-users-alt" style="margin-right: 5px"></i> Все</button>
                                <button type="button" :class="status === 'active' ? 'btn btn-primary' : 'btn btn-white'" @click="sortByStatus('active')"><i class="feather uil uil-user-check" style="margin-right: 5px"></i> Активные</button>
                                <button type="button" :class="status === 'wait' ? 'btn btn-primary' : 'btn btn-white'" @click="sortByStatus('wait')"><i class="feather uil uil-user-exclamation" style="margin-right: 5px"></i> На модерации</button>
                                <button type="button" :class="status === 'archive' ? 'btn btn-primary' : 'btn btn-white'" @click="sortByStatus('archive')"><i class="uil uil-archive-alt" style="margin-right: 5px"></i> Архив</button>
                                <button type="button" :class="status === 'blocked' ? 'btn btn-primary' : 'btn btn-white'" @click="sortByStatus('blocked')"><i class="uil uil-user-times" style="margin-right: 5px"></i> Заблокированы</button>
                            </div>

                            <label class="d-inline-flex align-items-center">
                                Поиск:
                                <b-form-input
                                    v-model="filter"
                                    type="search"
                                    @change="onFiltered()"
                                    placeholder="Введите текст..."
                                    class="form-control form-control-md ml-2"
                                ></b-form-input>
                            </label>
                        </div>
                    </div>
                    <!-- End search -->
                </div>
                
                <div class="card">
                    <div class="card-body" style="padding-left: 0px; padding-right: 0px;">

                        <!-- <div v-show="!disabled" class="row" style="margin-top: 0px; margin-bottom: 10px">
                            <div class="col-sm-6 col-md-6">
                                <div class="btn-group mb-2">
                                    <button id="btn-1" @click="deleteItems" type="button" class="btn btn-light">
                                        <b-tooltip target="btn-1">Удалить</b-tooltip>
                                        <i class="uil uil-trash-alt"></i>
                                    </button>
                                    <button id="btn-2" type="button" @click="updateStatus('wait')" class="btn btn-light">
                                        <b-tooltip target="btn-2">Отправить на модерацию</b-tooltip>
                                        <i class="uil uil-user-exclamation"></i>
                                    </button>
                                    <button id="btn-3" type="button" @click="updateStatus('archive')" class="btn btn-light">
                                        <b-tooltip target="btn-3">В архив</b-tooltip>
                                        <i class="uil uil-archive-alt"></i>
                                    </button>
                                    <button id="btn-4" type="button" @click="updateStatus('wait')" class="btn btn-light">
                                        <b-tooltip target="btn-4">Заблокировать</b-tooltip>
                                        <i class="uil uil-user-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div> -->

                        <div class="table-responsive mb-0">
                            <b-table
                                :items="table_data"
                                :fields="fields"
                                responsive="sm"
                                current-page="1"
                                :class = "tableLoading ? 'loading' : ''"
                                :sort-by.sync="sortBy"
                                :no-local-sorting="true"
                                ref="table"
                                :sort-desc.sync="sortDesc"
                            >
                                <!-- <template #head(select)="row">
                                    <input
                                        v-model="select_all"
                                        @change="selectAllRows"
                                        type="checkbox"
                                    />
                                </template>
                                <template #cell(select)="row">
                                    <input
                                        ref="checkbox"
                                        v-model="row.rowSelected"
                                        @change="selectRow(row)"
                                        type="checkbox"
                                    />
                                </template> -->
                                <template #cell(action)="row">
                                    <div style="text-align: right;">
                                        <b-dropdown
                                            variant="link"
                                            class="float-right"
                                            right
                                            toggle-class="p-0 text-muted arrow-none"
                                        >
                                            <template v-slot:button-content>
                                                <i class="uil uil-ellipsis-v font-size-14"></i>
                                            </template>
                                            <b-dropdown-item :to="{ name: 'Contacts.edit', params: { contact_uuid: row.item.uuid, copy: true }}"
                                                ><i class="uil uil-edit-alt mr-2"></i>Редактировать</b-dropdown-item
                                            >
                                        </b-dropdown>                                        
                                     </div>
                                </template>
                            </b-table>
                        </div>                    
                    </div>
                </div>

                <div class="row" style="margin-bottom: 30px">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-left"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="total_rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
	</Layout>
</template>

<style>
    .table-responsive-sm{
        transition: all .5s;
    }
    .table-responsive-sm.loading{
        opacity: 0.3;
    }
    .table-primary, .table-primary > th, .table-primary > td {
        background-color: #f5f5f5;
    }
    .table-primary th, .table-primary td, .table-primary thead th, .table-primary tbody + tbody {
        border-color: #ffffff;
    }
</style>